<template>
	<div data-component="general-deals-library">
		<search
			@search="onSearch"
			inputPlaceholder="Search by deal name"
		/>
		<filters
			:filters="getFilterOptions"
			@filter="onFilter"
		/>
		<div
			data-element="list"
			v-if="getGroups"
		>
			<general-deal-list-item
				v-for="(group, key) in getGroups"
				:key="key"
				:group="group"
				:deals="getDeals"
				@addDealToSelection="addDealToSelection"
				@removeDealFromSelection="removeDealFromSelection"
			/>
		</div>
		<records-count
			:pagination="getPagination"
			:total="getTotalItems"
		/>
		<pagination
			v-bind="getPagination"
			@paginate="onPaginate"
		/>
	</div>
</template>

<script>

	import Search from '@/components/ui/views/SearchInput';
	import Filters from '@/components/ui/views/filters/Filters';
	import GeneralDealListItem  from '@/components/dealLibrary/GeneralDealListItem';
	import RecordsCount from '@/components/ui/views/RecordsCount';
	import Pagination from '@/components/ui/views/Pagination';
	import routeParams from '@/mixins/routeParams';

	export default {
		components: {
			GeneralDealListItem,
			Search,
			Filters,
			RecordsCount,
			Pagination
		},
		mixins: [routeParams],
		props: {
			deals: {
				type: Array,
				default: undefined
			}
		},
		data: () => ({
			isWaiting: false
		}),
		computed: {
			getDeals () {
				return this.deals || [];
			},
			getFilterOptions () {
				return this.$store.getters['dealLibrary/getFilterOptions'] || [];
			},
			getGroups () {
				return this.$store.getters['dealLibrary/getGroups'];
			},
			getPagination () {
				return this.$store.getters['dealLibrary/getPagination'];
			},
			getTotalItems () {
				return this.$store.getters['dealLibrary/getTotalItems'] || 0;
			}
		},
		methods: {
			async setGroups () {
				await this.$store.dispatch('dealLibrary/setGroups');
				this.$store.commit('ui/setLoadingIsHidden');
			},
			onFilter (value) {
				this.$store.commit('dealLibrary/setCurrentPage', {
					currentPage: 1
				});
				this.$store.commit('dealLibrary/setActiveFilters', {
					activeFilters: value
				});
				this.setGroups();
			},
			onSearch (value) {
				this.$store.commit('dealLibrary/setSearchString', {
					searchString: value
				});
				this.setGroups();
			},
			onPaginate (value) {
				this.$store.commit('dealLibrary/setCurrentPage', {
					currentPage: value
				});
				this.setGroups();
			},
			addDealToSelection (deal) {
				this.$emit('addDealToSelection', deal);
			},
			removeDealFromSelection (deal) {
				this.$emit('removeDealFromSelection', deal);
			}
		}
	};
</script>

<style lang="scss" scoped>

	[data-component='select-deals-modal'] {
	}

</style>
